import searchReducer, { initialState } from './reducer';
import searchActions from './actions';

export { initialState, searchActions };
export default searchReducer;